import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogClose, MatDialogTitle } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { ReferralAgentActionType } from 'app/settings/store/referral-agents/referral-agents.interfaces';
import { CreateReferralAgentComponent } from './create-referral-agent/create-referral-agent.component';
import { LinkAccountComponent } from './link-account/link-account.component';
import { ReferralAgentActionTypePipe } from './referral-agent-action-type.pipe';
import { UpdateReferralAgentComponent } from './update-referral-agent/update-referral-agent.component';

@Component({
  selector: 'app-referral-agent-details-dialog',
  templateUrl: './referral-agent-details-dialog.component.html',
  styleUrls: ['./referral-agent-details-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatDialogClose,
    MatDialogTitle,
    ReferralAgentActionTypePipe,
    MatIconButton,
    MatIcon,
    CreateReferralAgentComponent,
    UpdateReferralAgentComponent,
    LinkAccountComponent,
  ],
})
export class ReferralAgentDetailsDialogComponent {
  public readonly data = inject<ReferralAgentActionType>(MAT_DIALOG_DATA);
}
